<template>
  <div class="p-bottom-4">
    <div v-if="!filteredRequestLoading">
      <div class="timeline-tab-subheader">
        <slot name="timelineFilter" />
      </div>
      <div class="card-container">
        <slot name="cards" v-if="!noTimeline"></slot>
      </div>
      <div class="timeline-tab-empty" v-if="noTimeline">
        <p class="level-item is-size-4 has-text-grey has-text-centered p-12">
          No timeline events matching the current filter found on this request
        </p>
      </div>
    </div>
    <NrLoadingAnimation v-else :count="3" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'

export default {
  props: {
    noTimeline: {
      type: Boolean,
      default: true
    }
  },

  components: {
    NrLoadingAnimation
  },

  computed: {
    ...mapState('request_show', ['filteredRequestLoading'])
  }
}
</script>

<style lang="scss">
.timeline-tab {
  &-empty {
    background: white;
    margin: 1.5rem 0;
  }
  &-subheader {
    padding: 8px;
    display: flex;
    .dropdown-trigger {
      button {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
    }
  }
}
</style>
